// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dropdown-block>.el-button-group{display:flex}.el-dropdown-block>.el-button-group>button:not(.el-dropdown__caret-button){padding:0;border:0}.el-dropdown-block>.el-button-group>.el-button.el-button--small .el-button-group-block>.el-button{padding:9px 15px}.el-button-group-block>.el-button:last-child{border-left-color:transparent;margin-right:0}", ""]);
// Exports
module.exports = exports;
